<template>
    <div class="page_czj flex-col">

        <div class="block_server flex-col">

            <div class="box_9 flex-col">
                <div class="text-group_229 flex-col justify-between">
                    <span class="text_45">服务优势</span>
                    <span class="text_46">SERVICE&nbsp;ADVANTAGES</span>
                </div>

                <div class="block_27 flex-col">
                    <div class="box_10 flex-col">
                        <div class="section_52_top"></div>

                        <div
                                v-for="(item, index) in serviceAdvantages"
                                :key="index"
                                class="section_53 flex-row justify-between"
                                @mouseenter="activeIndex = index"
                        >
                            <div class="circle-wrapper">
                                <div :class="activeIndex === index ? 'group_13_select' : 'group_13'">
                                    <div v-if="activeIndex === index" class="group_11"></div>
                                </div>
                            </div>

                            <div class="image-text_194 flex-row justify-between">
                                <span class="text_47">{{ item.title }}</span>
                                <img
                                        v-show="activeIndex === index"
                                        class="thumbnail_1"
                                        src="../../../assets/home/chpc_about_arrow_01.png"
                                />
                            </div>
                        </div>

                        <transition name="content-fade" mode="out-in">
                            <div class="group_16 flex-col" :key="activeIndex">
                                <span class="text_50">{{ currentAdvantage.title }}</span>
                                <img class="image_15" referrerpolicy="no-referrer" src="../../../assets/home/chpc_about_line_02.png"/>
                                <div class="text-group_230 flex-col justify-between">
                                    <div class="text-wrapper_6">
                                        <template v-for="(line, i) in currentAdvantage.content">
                    <span :key="i" class="text_51">{{ line }} <br />
                    </span>
                                        </template>
                                    </div>
                                    <span class="text_57">{{ currentAdvantage.note }}</span>
                                </div>

                            </div>
                        </transition>


                    </div>
                </div>

            </div>

        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                activeIndex: 0,
                serviceAdvantages: [
                    {
                        title: '经验优势',
                        content: [
                            '300+ 家 年均可疑商户走访量',
                            '900+ 份 年均HCO/CSO/DLR DD报告',
                            '7000+ 次 年均商业及终端执行量',
                            '8000+ 次 近3年走访经销商',
                            '超590+ 个 近3年执行要盖城市'
                        ],
                        note: '*上述“年均”概念以近3年企业实际数据统计获得'
                    },
                    {
                        title: '团队优势',
                        content: [
                            '100+资深核查团队',
                            '数十位源于行业的资深项目总监',
                            '核心团队成员拥有20年以上服务经验',
                            '项目总监拥有10年以上大型项目成功核查经验',
                        ],
                        note: null
                    },
                    {
                        title: '技术优势',
                        content: [
                            '创新产品数据分析系统',
                            '多种健康度评估模型',
                            '多样性的业务系统',
                            '人工智能工具集',
                        ],
                        note: null
                    },
                    {
                        title: '业务优势',
                        content: [
                            '10大中心支援全国业务',
                            '30+大型药械外企优选供应商',
                            '100+客户领域涵盖医药、器械、动保、人保、快消等',
                            '客户整体满意度达95%+',
                        ],
                        note: '*近三年客户项目及服务质量问卷调研整体满意度95分及以上约占8成。'
                    },
                    // 其他优势数据...
                ],
                constants: {}
            };
        },
        computed: {
            currentAdvantage() {
                return this.serviceAdvantages[this.activeIndex];
            }
        },
        methods: {}
    };
</script>
<style scoped lang="css"  >
    .page_czj {
        background-color: rgba(255, 255, 255, 1);
        position: relative;
        width: 1468px;
        overflow: hidden;
    }

    .block_server {
        position: relative;
        width: 1468px;
        margin-bottom: 1px;
        align-items: center;
    }

    .box_9 {
        width: 1200px;
        height: 682px;
        background: url(../../../assets/home/chpc_about_bj_02.png) 100% no-repeat;
        background-size: 100% 100%;
        align-items: center;
    }

    .text-group_229 {
        width: 400px;
        height: 96px;
        margin: 50px 0 0 0;
    }

    .text_45 {
        width: 400px;
        height: 53px;
        overflow-wrap: break-word;
        color: rgba(18, 20, 28, 1);
        font-size: 38px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: center;
        white-space: nowrap;
        line-height: 53px;
    }

    .text_46 {
        width: 400px;
        height: 37px;
        overflow-wrap: break-word;
        color: rgba(135, 135, 135, 1);
        font-size: 26px;

        text-align: center;
        white-space: nowrap;
        line-height: 37px;
        margin-top: 6px;
    }

    .block_27 {
        height: 350px;
        /*background: url(./assets/img/978ec5e4fd0341d1918f7f15d1d68d3e_mergeImage.png) 100% no-repeat; */
        background-size: 100% 100%;
        width: 1200px;
        margin: 47px 0 139px 0;
    }

    .box_10 {
        height: 350px;
        background: url(../../../assets/home/chpc_about_bj_03.png)
        100% no-repeat;
        background-size: 100% 100%;
        width: 1200px;
        position: relative;
        justify-content: flex-center;
    }

    .section_52_top {
        margin: 50px 0 0 79px;
    }

    .section_53 {
        width: 172px;
        height: 33px;
        margin: 24px 0 0 86px;
    }
    .justify-between {
        display: flex;
        justify-content: space-between;
    }
    .flex-row {
         display: flex;
         flex-direction: row;
    }
    .flex-col {
        display: flex;
        flex-direction: column;
    }
    .section_53 .circle-wrapper {
        width: 28px;
        height: 28px;
        position: relative;
        margin-top: 2px; /* 保持原有间距 */
    }

    .group_13 {
        background-color: rgba(255, 255, 255, 0.4);
        border-radius: 50%;
        width: 14px;
        height: 14px;


        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        transition: all 0.3s ease;
    }

    .group_13_select {
        background-color: rgba(255, 255, 255, 0.42) !important;
        border-radius: 50%;
        height: 28px;
        margin-top: 2px;
        width: 28px;

        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }


    .section_53:hover .text_47 {
        color: #fff;
    }

    .group_11 {
        background-color: rgba(255, 255, 255, 1);
        border-radius: 50%;
        width: 14px;
        height: 14px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }

    .image-text_194 {
        width: 121px;
        height: 33px;
    }


    .thumbnail_1 {
        width: 12px;
        height: 14px;
        margin-top: 10px;
    }





    .text_47 {
        width: 97px;
        height: 33px;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 24px;
        letter-spacing: 0.034285712987184525px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: left;
        white-space: nowrap;
        line-height: 33px;

        transition: color 0.3s ease;
    }


    /* 新增过渡效果 */
    .content-fade-enter-active,
    .content-fade-leave-active {
        transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
        position: absolute;
    }

    .content-fade-enter {
        opacity: 0;
        transform: translateX(30px);
    }

    .content-fade-leave-to {
        opacity: 0;
        transform: translateX(-30px);
    }

    /* 保持原有样式基础上添加定位 */
    .group_16 {
        position: absolute;
        left: 358px;
        top: 46px;
        width: 777px;
        height: 393px;
        /* 其他样式保持不变 */
    }


    .group_16 {
        position: absolute;
        left: 358px;
        top: 46px;
        width: 777px;
        height: 393px;
        background: url(../../../assets/home/chpc_about_bj_04.png) -60px -60px
        no-repeat;
        background-size: 897px 513px;
        box-shadow: 0px 0px 60px 0px rgba(0,0,0,0.2);
    }
    .flex-col {
        display: flex;
        flex-direction: column;
    }

    .text_50 {
        width: 117px;
        height: 41px;
        overflow-wrap: break-word;
        color: rgba(0, 134, 131, 1);
        font-size: 29px;
        letter-spacing: 0.041428569704294205px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: left;
        white-space: nowrap;
        line-height: 41px;
        margin: 42px 0 0 91px;
    }

    .image_15 {
        width: 57px;
        height: 1px;
        margin: 15px 0 0 91px;
    }

    .text-group_230 {
        width: 504px;
        height: 247px;
        margin: 10px 0 37px 91px;
    }

    .text-wrapper_6 {
        width: 550px;
        height: 200px;
        overflow-wrap: break-word;
        font-size: 0;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: left;
        line-height: 40px;
        margin-bottom: 20px;
    }

    .text_51 {
        width: 370px;
        height: 200px;
        overflow-wrap: break-word;
        color: rgba(102, 102, 102, 1);
        font-size: 22px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: left;
        line-height: 40px;
    }

    .paragraph_4 {
        width: 370px;
        height: 200px;
        overflow-wrap: break-word;
        color: rgba(102, 102, 102, 1);
        font-size: 22px;
        font-weight: 600;
        text-align: left;
        line-height: 40px;
    }


    .text_57 {
        width: 502px;
        height: 22px;
        overflow-wrap: break-word;
        color: rgba(102, 102, 102, 1);
        font-size: 16px;
        letter-spacing: 0.022857142612338066px;
        font-weight: NaN;
        text-align: left;
        white-space: nowrap;
        line-height: 22px;
        margin: 25px 0 0 2px;
    }


</style>
